// record (vod) repository

import http from '../services/http'
import auth from '../services/auth'
import store from '@/store'

const BASE_ROUTE = '/marker'
const BASE_RECORD_ROUTE = '/record'

export default {
  // fetch a list of vods for a marker
  fetchMarkerRecords: function (
      marker, page, pageSize, ordering, department,
      filters = {}, recordType = '', activeTab = 'new', ids = []
  ) {
    let query = ''
    let offset = (page - 1) * pageSize
    let isDeleted = 'False'
    // old tabs - 0,1; new tabs - new, approved, deleted
    // handle both cases
    if (activeTab === 'deleted' || activeTab === 1) isDeleted = 'True'
    let approved = null
    if (activeTab === 'approved') approved = 'True'
    else approved = 'False'
    let getParams = {
      'tags': filters.tags || [],
      'record_type': recordType,
      'is_deleted': isDeleted,
      'limit': pageSize,
      'offset': offset,
      'ids': ids,
      'ordering': ordering,
      'department': department,
    }
    if (approved) getParams.approved_ghosts = approved
    if (filters.lmr_category) getParams.lmr_category = filters.lmr_category
    if (filters.lmr_cities.length) getParams.lmr_cities = filters.lmr_cities
    if (filters.editor_consumers.length) getParams.editor_consumers = filters.editor_consumers
    if (filters.user) getParams.source__user = filters.user.pk
    if (filters.sdk_record) getParams.sdk_record = filters.sdk_record
    if (recordType === 'VIDEO') {
      if (filters.inappropriate === 'only') {
        getParams.is_inappropriate = 'True' // show only inappropriate records
      } else if (filters.inappropriate === 'hide') {
        getParams.is_inappropriate = 'False' // filter out inappropriate records
      }
    }
    query = encodeQueryData(getParams)
    // if (tags.length !== 0) {
    //   query = `${query}&tags=${tags.join(',')}`
    // }
    const baseUrl = markerRecordsBaseUrl(marker && marker.id)
    const url = `${baseUrl}/?${query}`
    return http.get(url, auth.getAuthHeader(), undefined, true).then(apiListToModels).then(
      function (records) {
        if (marker && recordType === 'VIDEO' && records.count > 0) {
          // temporary disabled
          fetchMLData(records, marker)
        }
        return records
      }
    )
  },
  // fetch a list of vods for a marker
  fetchMarkerRecordsByIds: function (marker, recordType, ids = []) {
    let query = encodeQueryData({ 'ids': ids })
    const baseUrl = markerRecordsBaseUrl(marker.id)
    const url = `${baseUrl}/?${query}`
    return http.get(url, auth.getAuthHeader(), undefined, true).then(apiListToModels).then(
      function (records) {
        if (marker && recordType === 'VIDEO' && records.count > 0) {
          // temporary disabled
          fetchMLData(records, marker)
        }
        return records
      }
    )
  },
  // fetch a list of vods for a marker
  fetchMarkerRecordCoords: function (markerId, filters = {}, recordType, activeTab = 0) {
    let query = ''
    let isDeleted = 'False'
    if (activeTab === 0) isDeleted = 'False'
    else isDeleted = 'True'
    let getParams = {
      'tags': filters.tags || [],
      'record_type': recordType,
      'is_deleted': isDeleted,
    }
    if (filters.lmr_category) {
      getParams.lmr_category = filters.lmr_category
    }
    if (filters.lmr_cities.length) {
      getParams.lmr_cities = filters.lmr_cities
    }
    if (recordType === 'VIDEO') {
      if (filters.inappropriate === 'only') {
        getParams.is_inappropriate = 'True' // show only inappropriate records
      } else if (filters.inappropriate === 'hide') {
        getParams.is_inappropriate = 'False' // filter out inappropriate records
      }
    }
    query = encodeQueryData(getParams)
    const baseUrl = markerRecordCoordsBaseUrl(markerId)
    const url = `${baseUrl}/?${query}`
    return http.get(url, auth.getAuthHeader(), undefined, true)
  },
  // fetch all unique tags of records of the marker
  fetchMarkerRecordTags: function (markerId) {
    const baseUrl = markerRecordsBaseUrl(markerId)
    const url = `${baseUrl}/tags/`
    return http.get(url, auth.getAuthHeader(), undefined, true)
  },
  // fetch a list of related vods for marker
  // these are self-initiated videos that were shot in the area of the marker
  // and at the time the marker was active, but were not specifically recorded
  // in response to the marker
  fetchMarkerRelatedRecords: function (markerId, activeTab = 0) {
    let isDeleted = 'False'
    if (activeTab === 0) isDeleted = 'False'
    else isDeleted = 'True'
    let query = encodeQueryData({'is_deleted': isDeleted})
    const baseUrl = `${BASE_ROUTE}/${markerId}/record/vod/related`
    const url = `${baseUrl}/?${query}`
    return http.get(url, auth.getAuthHeader(), undefined, true)
  },
  // fetch a list of the most similar records found for the given record
  fetchSimilarRecords: function (markerId, recordId) {
    return http.get(
      `${BASE_ROUTE}/${markerId}/record/vod/${recordId}/similar/`,
      auth.getAuthHeader(), undefined, true
    )
  },
  // fetch the marker dendrogram
  fetchMarkerRecordsDiversityTree: function (markerId) {
    return http.get(
      `${BASE_ROUTE}/${markerId}/record/vod/diversity/`,
      auth.getAuthHeader(), undefined, true
    )
  },
  // hide a record from the list of records for this marker
  deleteRecord: function (markerId, record) {
    const baseUrl = markerRecordsBaseUrl(markerId)
    return http.delete(`${baseUrl}/${record.id}/`, auth.getAuthHeader())
  },
  // restore a record and display it on the New tab
  restoreRecord: function (markerId, record) {
    let payload = {
      'mldata': {
        'deleted_at': null,
      }
    }
    return this.patchRecord(markerId, record, payload)
  },
  rejectRecords (recordIds) { // same as delete
    const baseUrl = markerRecordsBaseUrl()
    return http.post(`${baseUrl}/reject/`, auth.getAuthHeader(), {
      records: recordIds
    })
  },
  approveRecords (recordIds) {
    const baseUrl = markerRecordsBaseUrl()
    return http.post(`${baseUrl}/approve/`, auth.getAuthHeader(), {
      records: recordIds
    })
  },
  mergeRecords (recordIds, mergeData) {
    const data = Object.assign({ records: recordIds }, mergeData)
    return http.post(`/record/mp/merge/`, auth.getAuthHeader(), data)
  },
  restoreRecords (recordIds) { // remove 'deleted' marker
    const baseUrl = markerRecordsBaseUrl()
    return http.post(`${baseUrl}/restore/`, auth.getAuthHeader(), {
      records: recordIds
    })
  },
  // set thumbs up or thumbs down for a record
  patchRecordRelevance: function (markerId, record, relevance) {
    let payload = {
      'mldata': {
        'marked_as_relevant': relevance
      }
    }
    return this.patchRecord(markerId, record, payload)
  },
  // update notes for a record
  patchRecordNotes: function (markerId, record, notes) {
    let payload = {
      'mldata': {
        'notes': notes
      }
    }
    return this.patchRecord(markerId, record, payload)
  },
  patchRecordComment (record, payload) {
    return http.patch(
      `/record/feedback/${record.id}/comment/`, auth.getAuthHeader(), payload
    )
  },
  patchRecord (markerId, record, payload) {
    const baseUrl = markerRecordsBaseUrl(markerId)
    return http.patch(`${baseUrl}/${record.id}/`, auth.getAuthHeader(), payload)
  },
  fetchUserRecords (userId, page, pageSize, recordType, activeTab) {
    let isDeleted
    let offset = (page - 1) * pageSize
    if (activeTab === 0) isDeleted = 'False'
    else isDeleted = 'True'
    let getParams = {
      'record_type': recordType,
      'is_deleted': isDeleted,
      'limit': pageSize,
      'offset': offset
    }
    let query = encodeQueryData(getParams)
    const baseUrl = userRecordsBaseUrl(userId)
    const url = `${baseUrl}/?${query}`
    return http.get(url, auth.getAuthHeader()).then(apiListToModels)
  },
  // restore a record and display it on the Approved tab
  restoreUserRecord: function (userId, recordId) {
    let payload = {
      'mldata': {
        'deleted_at': null
      }
    }
    return this.patchUserRecord(userId, recordId, payload)
  },
  deleteUserRecord (userId, recordId) {
    const baseUrl = userRecordsBaseUrl(userId)
    const url = `${baseUrl}/${recordId}/`
    return http.delete(url, auth.getAuthHeader())
  },
  patchUserRecordRelevance: function (userId, recordId, relevance) {
    let payload = {
      'mldata': {
        'marked_as_relevant': relevance
      }
    }
    this.patchUserRecord(userId, recordId, payload)
  },
  patchUserRecord (userId, recordId, payload) {
    const baseUrl = userRecordsBaseUrl(userId)
    const url = `${baseUrl}/${recordId}/`
    return http.patch(url, auth.getAuthHeader(), payload)
  },
  requestMoreVideos (recordId, message) {
    // sends push notification to users with more videos request
    const url = `/record/mp/${recordId}/request_more/`
    return http.post(url, auth.getAuthHeader(), { message })
  },
  cutVideo (recordId, start, stop) {
    return http.post(`/record/mp/${recordId}/cut/`, auth.getAuthHeader(), {
      start, stop
    })
  },
  getRecordCutState (recordId) {
    return http.get(`/record/mp/${recordId}/cut_state/`, auth.getAuthHeader())
  },
  updateRecordTags (recordId, tagNames) {
    return http.post(`/record/mp/${recordId}/update_tags/`, auth.getAuthHeader(), {
      tags: tagNames
    })
  },
  patchRecordEdition (recordId, payload) {
    const url = `${BASE_RECORD_ROUTE}/${recordId}/change_edition/`
    return http.patch(url, auth.getAuthHeader(), payload)
  },
  getRecordsStatuses (recordIds) {
    // background status poll (runs every 10s) — pass silent=true so it doesn't
    // drive the global loading bar / connectivity error modal; the caller
    // handles failures itself at a throttled cadence.
    return http.get(
      `/process_statuses/`, auth.getAuthHeader(),
      {record: recordIds}, true
    )
  },
  downloadRecordsZip (recordIds) {
    const data = Object.assign({ records: recordIds })
    return http.post(`/images/download/zip`, auth.getAuthHeader(), data)
  },
  setDownloaded (recordName) {
    const url = `${BASE_RECORD_ROUTE}/downloaded/`
    const data = Object.assign({ record_name: recordName })
    return http.post(url, auth.getAuthHeader(), data)
  }
} // export default

function encodeQueryData (data) {
  const ret = []
  for (let d in data) {
    if (!isEmpty(data[d])) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]))
    }
  }
  return ret.join('&')
}

function userRecordsBaseUrl (userId) {
  return `/media_platform/user/${userId}/record/vod`
}

function markerRecordsBaseUrl (markerId) {
  return markerId ? `${BASE_ROUTE}/${markerId}/record/vod` : `/self_initiated_records`
}
function isEmpty (value) {
  return (value == null || value.length === 0)
}

function markerRecordCoordsBaseUrl (markerId) {
  return `${BASE_ROUTE}/${markerId}/record/vod_coords`
}

function apiListToModels (payload) {
  let result = payload['results']
  result.count = payload['count']
  return result
}

// Write a some wrapper for Joppe's endpoints
function fetchMLData (records, marker) {
  let payload = records.reduce(function (acc, cur) {
    acc[cur.id] = cur.mltags
    return acc
  }, {})
  payload.event_id = marker.id
  payload.request_title = marker.ml_keyword
  let options = {
    method: 'POST',
    body: JSON.stringify(payload)
  }
  // service fails if request_title is empty or consists of numbers
  if (!payload.request_title) return // disable request for empty request_title
  // roulatra only needs this data, so disable request for other consumers
  // maybe connected ml engines parameter will be added in future
  // so we could send request only for consumers with connected KUL
  if (store.state.consumerName !== store.state.CONSUMERS.roularta) return
  fetch('https://veriflix-ml-api.look-app.net', options)
    .then((response) => {
      if (response.status === 500) {
        console.warn(
          `ml failed. request_title: ${payload.request_title};`,
          response.statusText
        )
        return null
      } else return response.json()
    })
    .then(function (payload) {
      if (payload === null) return
      records.map(function (record) {
        let videos = payload.videos
        if (videos[record.id] !== undefined) {
          Object.assign(record.mldata, videos[record.id])
        }
      })
    })
}

